exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spectacle-deck.start-from-last-slide{text-align:center}.spectacle-deck.start-from-last-slide .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif;padding:1em 0;margin:0}.spectacle-deck.start-from-last-slide .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/startFromLastSlideModal.scss
// module id = 1313
// module chunks = 2